"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationSuccessScreen = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var CheckCircle_1 = __importDefault(require("@mui/icons-material/CheckCircle"));
var __1 = require("..");
var contexts_1 = require("../../contexts");
/**
 * Component that renders a success screen for when registration completes.
 *
 * @param icon the icon to be displayed on the screen
 * @param messageTitle title of the success message
 * @param message success message to be displayed on the screen
 * @param onDismiss function to call when user clicks button
 * @param canDismiss function to call when the dismiss button is clicked
 *
 * @category Component
 */
var RegistrationSuccessScreen = function (props) {
    var _a = (0, contexts_1.useRegistrationContext)(), navigate = _a.navigate, routeConfig = _a.routeConfig;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, contexts_1.useRegistrationWorkflowContext)().screenData, _c = _b.AccountDetails, firstName = _c.firstName, lastName = _c.lastName, email = _b.CreateAccount.emailAddress, organization = _b.Other.RegistrationSuccessScreen.organizationName;
    var _d = props.icon, icon = _d === void 0 ? react_1.default.createElement(CheckCircle_1.default, { color: 'primary', sx: { fontSize: 100, mb: 2 } }) : _d, _e = props.messageTitle, messageTitle = _e === void 0 ? "".concat(t('bluiCommon:MESSAGES.WELCOME'), ", ").concat(firstName, " ").concat(lastName, "!") : _e, _f = props.message, message = _f === void 0 ? (react_1.default.createElement(Typography_1.default, { variant: "subtitle2" },
        react_1.default.createElement(react_i18next_1.Trans, { i18nKey: email
                ? 'bluiRegistration:REGISTRATION.SUCCESS_MESSAGE_ALT'
                : 'bluiRegistration:REGISTRATION.SUCCESS_MESSAGE_ALT_WITHOUT_EMAIL_PROVIDED', values: { email: email, organization: organization } },
            "Your account has successfully been created with the email ",
            react_1.default.createElement("b", null, email),
            " belonging to the",
            react_1.default.createElement("b", null, " ".concat(String(organization))),
            " org."))) : _f, _g = props.onDismiss, onDismiss = _g === void 0 ? function () { return navigate(routeConfig.LOGIN); } : _g, _h = props.canDismiss, canDismiss = _h === void 0 ? true : _h, WorkflowCardHeaderProps = props.WorkflowCardHeaderProps, WorkflowCardActionsProps = props.WorkflowCardActionsProps, otherRegistrationSuccessScreenProps = __rest(props, ["icon", "messageTitle", "message", "onDismiss", "canDismiss", "WorkflowCardHeaderProps", "WorkflowCardActionsProps"]);
    var workflowCardHeaderProps = __assign({ title: t('bluiRegistration:REGISTRATION.STEPS.COMPLETE') }, WorkflowCardHeaderProps);
    var workflowCardActionsProps = __assign(__assign({ nextLabel: t('bluiCommon:ACTIONS.FINISH'), showNext: true, canGoNext: canDismiss, fullWidthButton: true }, WorkflowCardActionsProps), { onNext: function () {
            var _a;
            onDismiss();
            (_a = WorkflowCardActionsProps === null || WorkflowCardActionsProps === void 0 ? void 0 : WorkflowCardActionsProps.onNext) === null || _a === void 0 ? void 0 : _a.call(WorkflowCardActionsProps);
        } });
    return (react_1.default.createElement(__1.SuccessScreenBase, __assign({ WorkflowCardHeaderProps: workflowCardHeaderProps, WorkflowCardActionsProps: workflowCardActionsProps, icon: icon, messageTitle: messageTitle, message: message }, otherRegistrationSuccessScreenProps)));
};
exports.RegistrationSuccessScreen = RegistrationSuccessScreen;
